export default function Title(options){
    let hours = options.hours
    let container_element
    // initialize()

    this.show = () =>{
        $(document).find('body').append(container_element)
        setTimeout(_=>{
            $(container_element).addClass('show')
        },100)
    }
    this.hide = () =>{
        $(container_element).removeClass('show')
        setTimeout(_=>{
            container_element.remove()
        },300)
    }

    this.generate = ()=>{
        container_element = document.createElement('div')
        $(container_element).addClass('product-title-container')
        setTitle()
        setPosition()
    }

    this.setHours = (new_h) =>{
        hours = new_h
        setTitle()
    }

    function setPosition(){
        $(container_element).css('top', $('#main_header').height())
    }

    function setTitle(){
        let text = hours > 1 ? "Últimas "+hours+" horas" : "Últimos 60 minutos"
        $(container_element).html("<div class='title'>SIBH - CHUVA AGORA</div><div>"+text+"</div>")
    }
}